import React, { useMemo } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import cx from 'classnames';

import { useIsWidthUp } from '../../theme';
import { ExpertsSlider } from '../ExpertsSlider';
import useStyles from './styles';

type tileType = 'light' | 'dark';

const getCardBackground = (back, inverse = true): tileType => {
  if (inverse) {
    return back === 'Light' ? 'dark' : 'light';
  }

  return back === 'Light' ? 'light' : 'dark';
};

export const ExpertsBlock = ({ data: expertsData,  forceDarkOnMobile = true }) => {
  const isMobile = !useIsWidthUp('sm');
  const background = expertsData?.background;
  const heading = expertsData?.heading;
  const description = expertsData?.description;
  const items = useMemo(() => {
    return expertsData?.items
      ? expertsData.items.map((item) => item?.expert).filter((item) => item)
      : [];
  }, [expertsData]);
  const classes = useStyles(background, forceDarkOnMobile)();

  const expertTileType: tileType = forceDarkOnMobile
    ? getCardBackground(background, !isMobile)
    : getCardBackground(background, true);

  return (
    <Box
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'experts-block',
      )}
    >
      <Container className={classes.container}>
        <div className={classes.content}>
          <Box className={classes.headingWrapper}>
            <Typography variant="h2" component="h2" align="center" className={classes.heading}>
              {heading}
            </Typography>
            <Typography className={classes.description}>{description}</Typography>
          </Box>

          <ExpertsSlider experts={items} tileType={expertTileType} withLinks />
        </div>
      </Container>
    </Box>
  );
};

export default ExpertsBlock;
